var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blog-listings-section',{staticClass:"blog-listings-section-module",attrs:{"blogs":_vm.blogPosts,"current-page":_vm.currentPage,"total-pages":_vm.totalPages}})}
var staticRenderFns = []

export { render, staticRenderFns }